import { render, staticRenderFns } from "./NkChartPre.vue?vue&type=template&id=f5748282&scoped=true"
import script from "./NkChartPre.vue?vue&type=script&lang=js"
export * from "./NkChartPre.vue?vue&type=script&lang=js"
import style0 from "./NkChartPre.vue?vue&type=style&index=0&id=f5748282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5748282",
  null
  
)

export default component.exports